import { Link, useLocation } from 'react-router-dom';
import { Tooltip } from '@mui/material';
import { useDispatch } from 'react-redux';
import { unwrapResult } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';

import { errorNormalizer } from '../../shared/Helpers/functions';
import { useCheckPermission } from '../../shared/Helpers/hooks';
import { PERMISSIONS } from '../../App/constants';
import AccountDetails from './accountDetails';
import { AdminTypes } from '../Menu';
import Delete from '../Delete';

import { DispatchProperties } from '../../redux/store';
import { UserProperties } from '../../redux/API/userAPIProperties';
import { deleteUser } from '../../redux/State/userSlice';
import { EditSvg } from '../../shared/Assets/svgIcons';

const UserAction = ({
	item,
	fetchUsers,
	hideMoreInfo = false,
}: {
	fetchUsers: () => void;
	hideMoreInfo?: boolean;
	item: UserProperties;
}) => {
	const dispatch = useDispatch<DispatchProperties>();
	const EDIT = useCheckPermission(PERMISSIONS.USER.EDIT);
	const DELETE = useCheckPermission(PERMISSIONS.USER.DELETE);
	const { pathname } = useLocation();

	const onDeleteClick = (id: string) => {
		dispatch(deleteUser(id))
			.then(unwrapResult)
			.then(() => {
				toast(`Deleted`);
				fetchUsers();
			})
			.catch(errorNormalizer);
	};

	const onEditClick = () => {
		const roleType = item.role.section.id;
		if (typeof roleType !== 'number') return;
		window.localStorage.setItem('formType', AdminTypes[roleType]);
	};

	return (
		<div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
			{DELETE.permissionGranted && <Delete deleteHandler={() => onDeleteClick(item.id)} />}
			{EDIT.permissionGranted && (
				<Link to={`${pathname}/${item.id}`}>
					<Tooltip title="Edit">
						<div onClick={onEditClick}>
							<EditSvg />
						</div>
					</Tooltip>
				</Link>
			)}
			{!hideMoreInfo && <AccountDetails item={item} />}
		</div>
	);
};

export default UserAction;
